<template>
  <!-- 对话框 -->
  <el-dialog title="添加支付参数" :visible.sync="show" :before-close="closeDialog" style="width:1000px; margin: 0 auto;">

    <!-- 基本信息表单 -->
    <div class="form-box">
      <el-form label-width="80px">



        <el-form-item label="APP唯一标识:" label-width='130px'>
          <el-input v-model="submit_data.app_id" :placeholder="submit_rules.app_id.placeholder" style="width: 160px;">
          </el-input>
        </el-form-item>

        <el-form-item label="支付宝私钥 :" label-width='130px'>
          <el-input v-model="submit_data.privateKey" :placeholder="submit_rules.privateKey.placeholder" style="width: 160px;">
          </el-input>
        </el-form-item>

        <el-form-item label="支付宝公钥:" label-width='130px'>
          <el-input v-model="submit_data.publicKey" :placeholder="submit_rules.publicKey.placeholder" style="width: 160px;">
          </el-input>
        </el-form-item>



        <el-form-item label="状态:" label-width='130px'>
          <el-select v-model="submit_data.status" placeholder="请选择状态" style="width: 160px; margin-right: 20px;">
            <el-option label="启用" value="1">
            </el-option>
            <el-option label="禁用" value="0">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
<!--        <el-button type="primary" @click="addMerchantsSubmit">保存</el-button>-->
        <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="false"></submitBtn>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;

  export default {
    props: {
      'isShow': Boolean
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

      },

    },
    data() {
      return {

        show: false,


        submit_url:'/Alipay/addAlipaySubmit',
        // 表单提交数据
        submit_data: {
          app_id: '',
          privateKey: '',
          publicKey: '',
          status:''
        },

        submit_rules: {
          app_id: {
            placeholder: '请输入APP唯一标识',
            rules: {
              required: true,
              message: 'APP唯一标识错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          privateKey: {
            placeholder: '请输入支付宝私钥',
            rules: {
              required: true,
              message: '支付宝私钥错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          publicKey: {
            placeholder: '请输入支付宝公钥',
            rules: {
              required: true,
              message: '支付宝公钥错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          status: {
            placeholder: '请选择状态',
            rules: {
              required: true,
              message: '状态未选择',
              regulation: 'special',
              rulesData: '0|1'
            }
          }

        },

      };
    },
    created() {
      _this = this;

    },
    methods: {



      // 关闭方法
      closeDialog() {

        _this.show = false;

        _this.submit_data = {
          app_id: '',
          privateKey: '',
          publicKey: '',
          status:''
        }
      },

      // 提交按钮
      onSubmitDig() {





            _this.closeDialog();

            _this.$emit('onSubmit');



      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>